module.exports = require("lodash/isObject");